import React, { FC, useMemo } from 'react';
import { ChildrenProp } from '@/declarations/ChildrenProp';
import { useStore } from '@/components/store/Store';
import { EditorContext } from '../declarations/EditorContext';
import { EditorConfiguration } from './EditorConfiguration';
import { EditorConfigurationFactory } from '../factories/EditorConfigurationFactory';
import { Configuration } from './EditorConfigurationContext';

export interface EditorConfigurationProviderProps extends ChildrenProp {
  context: EditorContext;
}

/**
 * Provides the relevant configuration for the current EditorContext
 * @param children
 * @param context
 * @constructor
 */
export const EditorConfigurationProvider: FC<EditorConfigurationProviderProps> = ({ children, context }) => {
  const { state } = useStore();
  const isSuperAdmin = !!state?.currentUser?.user?.is_super_admin;

  const editorConfiguration = useMemo<EditorConfiguration>(() => {
    return EditorConfigurationFactory.makeConfiguration(context, isSuperAdmin);
  }, [context, isSuperAdmin]);

  return <Configuration.Provider value={editorConfiguration}>{children}</Configuration.Provider>;
};

export default EditorConfigurationProvider;
